module.exports = __webpack_public_path__ + "img/背景.f54d8880.png";